import React, { useEffect, useState, useRef } from 'react';
 import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4'; 

const VersionUpdateAbstract_data = async (parms) => {
  const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/VersionNotUpdateAbstract`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
};

const VersionUpdateAbstract  = ({type,dist_code}) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const fpscardstab = useRef(null); // Use ref to scroll to this div
  const [version, setVersion] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await VersionUpdateAbstract_data({ dist_code});
        console.log(dist_code);
        console.log(response_data);

        setTabHeading(response_data.heading);
        if (response_data.versionNotUpdateList && response_data.versionNotUpdateList.length > 0) {
            setVersion(response_data.headerversionNo)

            setReportData(response_data.versionNotUpdateList);
        } else {
          setReportData([]);
        }
      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [type,dist_code ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0); // Reset page to 0 when changing rows per page
  };

  
  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && fpscardstab.current) {
        fpscardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  if (error) {
    return <div className="mainhead" align="center">Internal Error</div>;
  }
  if (reportData.length === 0) {
    return <div className="mainhead" align="center">No data found</div>;
  }

  // Pagination logic
  const paginatedData = rowsPerPage === 'all' 
    ? reportData 
    : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <table ref={fpscardstab} align="center" width="80%" border={1}>
        <thead>
          <tr className="tableheader">
            <th colSpan={9}>{reportData[0].dist_name_en} {'New Version Not Updated Abstract'} {version}</th>
          </tr>
          <tr className="tableheader">
            <th rowSpan={2}>Sl.No</th>
            <th rowSpan={2}>FPS</th>
            <th rowSpan={2}>Dealer Name</th>
            <th rowSpan={2}>Dealer Mobile</th>

            <th rowSpan={2}>Device Id</th>
            <th rowSpan={2}>Version</th>

           </tr>
          
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={item.fps_id}>
              <td style={{ textAlign: 'center' }}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */}
              <td style={{ textAlign: 'left' }}>{item.fps_id}</td>
              <td style={{ textAlign: 'left' }}>{item.del_name}</td>
              <td style={{ textAlign: 'right' }}>{item.del_mob}</td>
              <td style={{ textAlign: 'left' }}>{item.terminal_id}</td>
              <td style={{ textAlign: 'right' }}>{item.version_no}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br /><br />
      <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
      <PaginationTable
        count={reportData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /></div>
             <br /><br /> <br /><br />

    </>
  );
};

export default VersionUpdateAbstract ;
